import { Leaf } from "./Leaf";

const ITEMS = ["Nourish", "Energise", "Transform", "Wellness coach, not dietitian", "Free 20-minute consultation", "120 days, coached"];

export function Marquee({ dark = false }: { dark?: boolean }) {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className={`relative overflow-hidden border-y py-6 sm:py-8 ${dark ? "border-cream/10 bg-forest text-cream" : "border-forest/10 bg-cream-sand text-forest"}`} aria-hidden="true">
      <div className="flex w-max animate-marquee items-center hover:[animation-play-state:paused]">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center">
            {row.map((t, i) => (
              <span key={`${k}-${i}`} className="flex items-center">
                <span className={`whitespace-nowrap px-6 font-display text-4xl sm:text-6xl ${i % 2 ? "italic" : ""}`}>{t}</span>
                <Leaf className="h-6 w-6 text-gold sm:h-8 sm:w-8" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
